import { defaultFileObj, defaultImageObj, defaultOctopusObj, defaultAddressObj } from "../libs/common";
import { defaultRenewInfoObj } from "../libs/personal/utils";
import { defineStore } from "pinia";

const defaultForm = () => {
  return {
    id: null,
    authen: false,
    authenObj: defaultAuthenObj(),
    renewInfo: defaultRenewInfoObj(),
    status: null,
    verified: false,
    type: null,
    companyCode: null,
    staffId: null,
    name: null,
    nameChi: null,
    gender: null,
    identity: {
      type: 0,
      number: null,
      checksum: null,
    },
    birthday: null,
    phone: null,
    mobile: null,
    email: null,
    addrObj: defaultAddressObj(1),
    country: null,
    language: null,
    photo: defaultImageObj(),
    octopus: defaultOctopusObj(),
    payment: {
      method: null,
      refNum: null
    },
    pickupStation: null,
    extension: null,
    cardImages: {
      front: defaultImageObj(),
      back: defaultImageObj()
    },
    workerProof: {
      type: null,
      content: defaultImageObj()
    }
  };
};

const defaultAuthenObj = () => {
  return {
    companyCode: null,
    name: null,
    mobile: null,
    email: null
  }
}

export const usePersonalStore = defineStore("personal", {
  state: () => {
    return {
      locale: null,
      jwt: null,
      agreement: false,
      complete: false,
      form: defaultForm(),
      isUploadSuccess: null
    }
  },
  actions: {
    updatePersonalLocale(val) {
      this.locale = val
    },
    updateForm(val) {
      this.form = val;
    },
    updateFormType(val) {
      this.form.type = val;
    },
    updateAgreement(val) {
      this.agreement = val;
    },
    updatePersonalToken(val) {
      this.token = val;
    },
    updatePersonalJWT(val) {
      this.jwt = val;
    },
    updatePersonalAppNo(val) {
      this.form.id = val;
    },
    updateComplete(val) {
      this.complete = val;
    },
    updateStatusForPayment() {
      this.agreement = true;
      this.form.authen = true;
      this.form.verified = true;
    },
    updatePersonalPaymentMethod(obj) {
      this.form.payment.method = obj.method,
      this.form.payment.refNum = obj.refNum
    },
    clearPersonalPaymentRefNum() {
      this.form.payment.refNum = null;
    },
    resetPersonalForm() {
      let formObj = defaultForm();
      formObj.type = this.form.type
      formObj.id = this.form.id
      this.form = formObj;
    },
    resetPersonalState(removeJWT = true) {
      let formObj = defaultForm();
      if(removeJWT) {
        this.jwt = null;
      } else {
        formObj.type = this.form.type
      }
      this.agreement = false;
      this.locale = null;
      this.complete = false;
      this.form = formObj;
    },
    resetAuthen() {
      this.form.authen = false;
      this.form.authenObj = defaultAuthenObj();
    },
    resetAuthenObj() {
      this.form.authenObj = defaultAuthenObj();
    },
    updateIsMobile(val) {
      this.isMobile = val
    },
    clearOctopusInfo() {
      this.form.octopus = defaultOctopusObj();
      this.form.cardImages.front = defaultFileObj();
      this.form.cardImages.back = defaultFileObj();
    },
    updateUploadFlag(val) {
      this.isUploadSuccess = val;
    },
    resetWorkerProof() {
      this.form.workerProof.type = null;
      this.form.workerProof.content = defaultImageObj();
    },
    resetWorkerProofContent() {
      this.form.workerProof.content = defaultImageObj();
    },
  },
  persist: true
});
